import { faSparkles } from "@fortawesome/pro-regular-svg-icons";

import { toDollars } from "common/utils/formatting";
import Icon from "common/components/Icon";

import Banner from "client/common/components/content/Banner";

import styles from "../../styles/EmployeePricingNote.module.less";

type EmployeePricingNoteProps = {
  savings?: number;
  isMapPriceAdjusted?: boolean;
};

const EmployeePricingNote = ({ savings, isMapPriceAdjusted = false }: EmployeePricingNoteProps) => {
  return (
    <Banner variant="info" className={styles.banner}>
      <div className={styles.general}>
        <Icon icon={faSparkles} />
        {isMapPriceAdjusted ? "Add to cart to view employee pricing" : "Employee pricing applied!"}
      </div>
      {!!savings && savings > 0 && (
        <div className={styles.savings}>
          You saved <span className={styles.amount}>{toDollars(savings)}</span> with your employee
          pricing!
        </div>
      )}
    </Banner>
  );
};

export default EmployeePricingNote;
